import React from 'react';
import { useTranslation } from 'react-i18next';

const EN_DEFAULT_ITEMS = [
  { value: '200M+', label: 'Persian-Speaking Audience' },
  { value: '1st', label: 'First & Largest Platform Dedicated to Persian' },
  { value: '80%', label: 'Content Creator Share' },
  { value: '24/7', label: 'New Content' },
];

const StatsBlock = () => {
  const { t } = useTranslation('auth');
  const d = {
    items: t('landing.stats.items', { returnObjects: true, defaultValue: EN_DEFAULT_ITEMS }),
  };

  return (
    <section className="py-20 sm:py-28">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-0 lg:divide-x lg:divide-gray-200 lg:dark:divide-white/[0.06]">
          {d.items.map((stat, i) => (
            <div key={i} className="text-center lg:px-8">
              <div className="cl-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-[-0.03em] mb-2" style={{ color: 'var(--color-primary, #10b981)' }}>{stat.value}</div>
              <div className="text-sm text-gray-500 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBlock;
